import { render } from "./slotBooking.vue?vue&type=template&id=0e108c32&scoped=true"
import script from "./slotBooking.vue?vue&type=script&lang=js"
export * from "./slotBooking.vue?vue&type=script&lang=js"

import "./slotBooking.vue?vue&type=style&index=0&id=0e108c32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e108c32"]])

export default __exports__